

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingCryptoCollectionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accounting-crypto-collections';
        this.Server =
            this.props.context.getState().server.accountingCryptoCollections;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'hash'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'walletId',
                label: 'wallet',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletWallets',
                object: 'wallet',
                show: 'publicAddress'
            },
            //HTTP error! status: 500, message: ERROR: column "requested_channels" is of type wallet.notification_channel[] but expression is of type character varying[] Hint: You will need to rewrite or cast the expression. Position: 167
            {
                id: 'systemAccountId',
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'accountingSystemAccounts',
                object: 'systemAccount',
                show: 'publicAddress'
            },
            {
                id: 'hash',
                label: 'hash',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: true,
                cell: 'CryptoAmount',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

